import { Component } from '@angular/core';
import { BeerServiceProvider } from "../../providers/beer-service/beer-service";
import { RequestUser/*, Analysis, WishlistAdd, WishlistRemove, WishlistGet, BeerProfileRequest, SearchRequest*/ } from "../../models/models";
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { Router } from '@angular/router';
import { BeerDetailPage } from '../../pages/beer-detail/beer-detail';
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from "../../providers/user-data/user-data";
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BeerDetailPage_PATH } from '../../app/app-constants';

/**
 * Generated class for the HighestRatedBeersComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'highest-rated-beers',
  templateUrl: 'highest-rated-beers.html',
  styleUrls: ['./highest-rated-beers.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ],
  animations: [
    trigger('collapse', [
      state('invisible', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('invisible <=> visible', animate('100ms'))
    ])
  ]
})
export class HighestRatedBeersComponent {
  public beers: Array<any>;
  public collapseState: string;

  constructor(
    private beerService: BeerServiceProvider,
    private router: Router,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private bhutil: BhutilProvider
  ) {

    this.userData.getUserID()
      .then((userID) => {
        let user = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);

        this.beerService.getTopBeers(user).subscribe(
          (resp: any) => {
            this.beers = resp;
            console.log(resp);
          },
          err => {
            console.log(err)
          });
      });
    this.collapseState = "visible";
  }

  toggleCollapse() {
    this.collapseState = (this.collapseState == 'visible') ? 'invisible' : 'visible';
  }

  showBeerDetail(b: any) {
    console.log("[highest-rated-beers] show details for beer " + b.beer.id + " => " + this.bhutil.stringify(b));

    //navigate to the detail screen, with the info preloaded
    this.router.navigate([ BeerDetailPage_PATH ], { state: { data: {
        'beer': b,
        'sourcetype': 'highest-rated-beers',
        'sourceID': 1
      }}});
    //sourceID 1 == HIGHEST-RATED-BEERS

  }

}
